import { render } from "./DefaultCardHeader.vue?vue&type=template&id=553514fe&scoped=true&ts=true"
import script from "./DefaultCardHeader.vue?vue&type=script&lang=ts"
export * from "./DefaultCardHeader.vue?vue&type=script&lang=ts"

import "./default-header.scss?vue&type=style&index=0&id=553514fe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553514fe"]])

export default __exports__